import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { HotelsEffects, HotelsReducer, HotelsStateFeatureKey } from "./store";
import { EventsReducer, EventsStateFeatureKey } from "../../events/src/app/data-access/store";
import { FlightsReducer, FlightsStateFeatureKey } from "../../flights-page/src/app/data-access/store";

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(EventsStateFeatureKey, EventsReducer),
    StoreModule.forFeature(FlightsStateFeatureKey, FlightsReducer),
    StoreModule.forFeature(HotelsStateFeatureKey, HotelsReducer),
    EffectsModule.forFeature([HotelsEffects]),
  ]
})
export class HotelsDataAccessModule { }
